import gsap from 'gsap';
import Sniffer from 'sniffer';
import TinyGesture from 'tinygesture';

export default class Contact {
  constructor() {
    this.contact = document.querySelector('.s-contact');
    this.wrap = document.querySelector('.s-contact-wrap');
    this.headings = document.querySelectorAll('.s-contact .f-xl');
    this.block = document.querySelectorAll('.s-contact-block');
    this.links = document.querySelectorAll('.s-contact-block a');
    this.images = document.querySelectorAll('.s-contact-image');

    this.index = 0;
    this.offset = 0;
    this.disabled = false;
    this.swipe = undefined;
    this.animating = false;
    this.direction = undefined;

    this.total = this.headings.length;

    this.pointer = {
      dot: document.querySelector('.a-pointer-dot'),
      label: document.querySelector('.a-pointer-label'),
    };

    this.gesture = undefined;

    if (Sniffer.isDevice) {
      this.gesture = new TinyGesture(this.contact);
    }
  }

  mouse = () => {
    this.pointer.label.innerHTML = 'Next';
    this.direction = 'next';
  }

  enter = () => {
    this.disabled = false;
    const tl = gsap.timeline();
    tl
      .to(this.pointer.dot, {
        opacity: 0,
        duration: 0.25,
      }, 0)

      .to(this.pointer.label, {
        opacity: 1,
        duration: 0.25,
      }, 0);
  }

  leave = () => {
    this.disabled = true;
    const tl = gsap.timeline();
    tl
      .to(this.pointer.dot, {
        opacity: 1,
        duration: 0.25,
      }, 0)

      .to(this.pointer.label, {
        opacity: 0,
        duration: 0.25,
      }, 0);
  }

  transform = () => {
    if (this.animating === true || this.disabled === true) return;

    this.animating = true;

    const addSpacing = window.innerWidth <= 580 ? 2.5 : 1;

    this.left = this.wrap.getBoundingClientRect().left;

    this.prevIndex = this.index;
    this.index += 1;
    if (this.index >= this.headings.length) this.index = 0;
    this.nextIndex = this.index + 1;
    if (this.nextIndex >= this.headings.length) this.nextIndex = 0;

    this.spacing = (this.wrap.getBoundingClientRect().width * 1.4) / 2;
    this.headings[this.index].setAttribute('data-currentIndex', 0);
    this.headings[this.nextIndex].setAttribute('data-currentIndex', 1);
    this.swipe = undefined;

    const i = this.index;
    const tl = gsap.timeline({
      onComplete: this.reset,
    });

    if (i !== this.prevIndex) {
      tl
        .to(this.headings, {
          x: (index, el) => {
            const currentIndex = parseInt(el.getAttribute('data-currentIndex'), 10);
            let x;

            switch (true) {
              case currentIndex === 0:
                x = 0;
                break;

              case currentIndex === 1:
                x = this.wrap.querySelector('[data-currentIndex="0"]').getBoundingClientRect().width + (50 / addSpacing);
                break;

              default:
                x = -300;
                break;
            }

            return x;
          },
          duration: 0.75,
          ease: 'expo.inOut',
        }, 0)
        .to(this.headings[this.prevIndex], {
          autoAlpha: 0,
        }, 0)
        .set(this.headings[this.prevIndex], {
          x: this.spacing * 100.5,
          autoAlpha: 0,
        }, 0.75)
        .to(this.headings[this.index], {
          autoAlpha: 1,
          duration: 1,
        }, 0)
        .to(this.headings[this.prevIndex], {
          x: () => this.wrap.querySelector('[data-currentIndex="0"]').getBoundingClientRect().width + this.wrap.querySelector('[data-currentIndex="1"]').getBoundingClientRect().width + (-40 / addSpacing),
          autoAlpha: 0.35,
          duration: 1,
          ease: 'expo.inOut',
        }, 0.76);
    }

    tl
      .to(this.block, {
        opacity: 0,
        duration: 0.75,
        pointerEvents: 'none',
      }, 0)

      .to(this.block[i], {
        opacity: 1,
        delay: 0.75,
        duration: 0.75,
        pointerEvents: '',
      }, 0)

      .set(this.images, { zIndex: 1 }, 0)
      .set(this.images[this.prevIndex], { zIndex: 2 }, 0)
      .set(this.images[i], { clipPath: 'inset(0% 0.0001% 0.0002% 100%)', zIndex: 3 }, 0)
      .to(this.images[i], {
        clipPath: 'inset(0.0001% 0.0002% 0.0003% 0.0004%)',
        duration: 0.5,
        pointerEvents: '',
      }, 0.25);
  }

  reset = () => {
    this.animating = false;
  }

  destroy = () => {
    if (Sniffer.isDevice) {
      this.gesture.off('swipeleft', this.transform);
      this.gesture.off('swiperight', this.transform);
      this.wrap.removeEventListener('click', this.handlerClickWrap);
    } else {
      this.contact.removeEventListener('mouseenter', this.enter);
      this.contact.removeEventListener('mouseleave', this.leave);

      window.removeEventListener('click', this.transform);
      window.removeEventListener('resize', this.resizeHandler);
      window.removeEventListener('mousemove', this.mouse);
    }
  }

  init = () => {
    if (Sniffer.isDevice) {
      this.gesture.on('swipeleft', () => {
        this.swipe = 'left';
        this.transform();
      });
      this.gesture.on('swiperight', () => {
        this.swipe = 'right';
        this.transform();
      });
      this.handlerClickWrap = () => {
        this.swipe = 'right';
        this.transform();
      };
      this.wrap.addEventListener('click', this.handlerClickWrap);
    } else {
      this.contact.addEventListener('mouseenter', this.enter);
      this.contact.addEventListener('mouseleave', this.leave);

      window.addEventListener('click', this.transform);
      window.addEventListener('mousemove', this.mouse);

      [...this.links].forEach((el) => {
        el.addEventListener('mouseenter', this.leave);
        el.addEventListener('mouseleave', this.enter);
      });
    }

    this.resizeHandler = () => {
      gsap.set('.s-contact-wrap [data-currentIndex="0"]', {
        x: 0,
      });
      gsap.set('.s-contact-wrap [data-currentIndex="1"]', {
        x: () => this.wrap.querySelector('[data-currentIndex="0"]').getBoundingClientRect().width + 50,
      });
      gsap.set('.s-contact-wrap [data-currentIndex="2"]', {
        x: () => this.wrap.querySelector('[data-currentIndex="0"]').getBoundingClientRect().width + this.wrap.querySelector('[data-currentIndex="1"]').getBoundingClientRect().width + 100,
      });
      this.transform();
    };

    window.addEventListener('resize', this.resizeHandler);

    this.spacing = (this.wrap.getBoundingClientRect().width * 1.4) / 3;
    gsap.set(this.headings[0], { x: 0, autoAlpha: 0.35 });
    gsap.set(this.headings[1], { x: this.spacing, autoAlpha: 1 });
    gsap.set(this.headings[2], { x: this.spacing * 2, autoAlpha: 0.35 });

    this.transform();
  }
}
